import { createContext } from "react";

// Context to share drag state between scrollable lists and their children
export const DragContext = createContext<{ isDragging: boolean; hasDragged: boolean }>({
  isDragging: false,
  hasDragged: false,
});